import {
  postGroupPurchaseAddGroupPurchaseUser,
  postGroupPurchaseCreateGroupPurchase,
  postGroupPurchaseGetGroupPurchase,
} from "api"
import OtpPage from "components/OtpStep/OtpPage"
import {
  GroupPurchasesSteps,
  useGroupPurchasesContext,
} from "components/PurchasePage/GroupPurchasesContext"
import { usePaymentContext } from "components/PurchasePage/Preview/Payment/PaymentContext"
import { usePurchaseContext } from "components/PurchasePage/PurchaseContext"
import { useRouter } from "next/router"
import { useEffect } from "react"
import { PaymentSteps } from "~/pages/groupPurchases/payment"

const OtpGroupPurchasesPage = () => {
  const router = useRouter()
  const {
    groupPurchasesData,
    setGroupPurchasesSteps,
    setGroupPurchasesData,
    setIsAdmin,
  } = useGroupPurchasesContext()
  const { setGroupPurchaseData, groupPurchaseGuid, setGroupPurchaseUserGuid } =
    usePurchaseContext()
  const { setPaymentSteps } = usePaymentContext()

  useEffect(() => {
    setGroupPurchasesSteps(GroupPurchasesSteps.LeaderDetails)
  }, [])

  return (
    <OtpPage
      type="groupPurchases"
      editLink="/groupPurchases"
      submit={async (success) => {
        if (success) {
          try {
            if (groupPurchaseGuid) {
              const addGroupPurchaseUser =
                await postGroupPurchaseAddGroupPurchaseUser({
                  ...groupPurchasesData,
                  groupPurchaseGuid: groupPurchaseGuid,
                })
              if (addGroupPurchaseUser) {
                setGroupPurchaseUserGuid(
                  addGroupPurchaseUser?.data?.body?.groupPurchaseUserGuid
                )
                try {
                  const getGroupPurchase =
                    await postGroupPurchaseGetGroupPurchase({
                      groupPurchaseGuid,
                    })
                  getGroupPurchase &&
                    setGroupPurchaseData(getGroupPurchase?.data?.body)
                  setGroupPurchasesSteps(GroupPurchasesSteps.LOADER)
                  getGroupPurchase && router.push("/groupPurchases/payment")
                  setPaymentSteps(PaymentSteps.PAYMENT)
                } catch (error) {
                  console.log(error)
                }
              }
            } else {
              const createGroupPurchesResponse =
                await postGroupPurchaseCreateGroupPurchase(groupPurchasesData)
              if (createGroupPurchesResponse) {
                setGroupPurchaseUserGuid(
                  createGroupPurchesResponse.data.body.groupPurchaseUserGuid
                )
                setGroupPurchasesData({
                  ...groupPurchasesData,
                  //@ts-ignore
                  guid: createGroupPurchesResponse?.data?.body
                    ?.groupPurchaseGuid,
                })
              }
              groupPurchasesData && setGroupPurchaseData(groupPurchasesData)
              setIsAdmin(true)
              setGroupPurchasesSteps(GroupPurchasesSteps.LOADER)
              router.push("/groupPurchases/payment")
              setPaymentSteps(PaymentSteps.PAYMENT)
            }
          } catch (error) {
            console.log(error)
          }
        }
      }}
    />
  )
}

export default OtpGroupPurchasesPage
